import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import i18next from 'i18next'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import * as requestTypeCode from '../../scripts/RequestTypeCode'
import * as leaveRequestStatusCode from '../../scripts/LeaveRequestStatusCode'
import * as storage from '../../utils/storage'
import PropTypes from 'prop-types'
import styles from '../../styles/request.module.css'
import { getAllListsPage } from '../../actions/request';
import { IsEnglish } from '../../utils/language';

const useStyles = makeStyles(theme => ({
    toolBar: {
        alignSelf: 'flex-end',
        color: "var(--color1) !important"
    },
    buttonFilter: {
        marginTop: '10px',
        border: '1px solid red'
    },
    appBar: {
        boxShadow: 'none !important'
    }
}));

function FilterRequest(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [listFilter, setListFilter] = React.useState([]);
    const [typeRequest, setTypeRequest] = React.useState({
        vacation: true,
        leave: true
    });
    const [status, setStatus] = React.useState({
        opened: true,
        closed: false,
        canceled: false,
        cancelationRequest: true
    });
    const [typeRequestValue, setTypeRequestValue] = React.useState(null);
    const [statusValue, setStatusValue] = React.useState(null);

    const [isFirst, setIsFirst] = React.useState(false);

    const { handleFilter } = props;

    useEffect(() => {
        loadPage();
    }, [])

    //useEffect(() => {
    //    //if (isFirst) {
    //    handleStorageFilter();
    //    //setIsFirst(true);
    //    //}
    //}, [listFilter])

    useEffect(() => {
        handleTypeRequestValue();
    }, [typeRequest])

    useEffect(() => {
        handleStatusValue();
    }, [status])

    useEffect(() => {
        // Workaround to pass the right parameters after the changing status on the page load

        if (isFirst) {
            //handleStorageFilter();

            handleFilter([typeRequestValue, statusValue]);
        }
    }, [isFirst])

    const loadPage = async () => {
        await loadFilter();
        await handleStorageFilter();
        setIsFirst(true);
    }

    const loadFilter = async () => {
        const result = await getAllListsPage();
        const requestTypeList = result.requestTypeList.filter(item => item.value == 4 || item.value == 5);

        return new Promise(resolve => {
            let typeRequestItems = [];

            requestTypeList.forEach(item => {
                typeRequestItems.push({ description: IsEnglish() ? item.descriptionFr : item.descriptionEn, key: item.descriptionEn.toLowerCase(), value: item.value })
            });

            var list = [
                {
                    typeFilter: i18next.t("request:filter.type-request"),
                    key: "typeRequest",
                    items: typeRequestItems
                },
                {
                    typeFilter: i18next.t("request:filter.status-request"),
                    key: "status",
                    items: [
                        {
                            description: "Opened",
                            key: "opened",
                            value: leaveRequestStatusCode.Status_Opened
                        },
                        {
                            description: "Closed",
                            key: "closed",
                            value: leaveRequestStatusCode.Status_Close
                        },
                        {
                            description: "Canceled",
                            key: "canceled",
                            value: leaveRequestStatusCode.Status_Canceled
                        },
                        {
                            description: "Cancelation request",
                            key: "cancelationRequest",
                            value: leaveRequestStatusCode.Status_Cancel_Request
                        }
                    ]
                }
            ];
            setListFilter(list);

            resolve();
        })
    }

    const handleStorageFilter = () => {
        return new Promise(resolve => {
            const filter = storage.getFilterRequest();

            if (filter !== undefined) {
                setTypeRequest(filter.typeRequest);
                setStatus(filter.status);
            }

            resolve();
        });
    }

    const handleOpenFilter = () => {
        setOpen(true);
    }

    const handleFilterSubmit = () => {
        handleFilter([typeRequestValue, statusValue]);
        handleSaveStorageFilter();

        setOpen(false);
    }

    const handleTypeRequestValue = () => {
        const arrayValue = [];

        if (typeRequest.leave) {
            arrayValue.push(requestTypeCode.Type_Leave);
        }
        if (typeRequest.vacation) {
            arrayValue.push(requestTypeCode.Type_Vacation);
        }

        setTypeRequestValue(arrayValue);
    }

    const handleStatusValue = () => {
        const arrayValue = [];

        if (status.opened) {
            arrayValue.push(leaveRequestStatusCode.Status_Opened);
        }
        if (status.closed) {
            arrayValue.push(leaveRequestStatusCode.Status_Close);
        }
        if (status.canceled) {
            arrayValue.push(leaveRequestStatusCode.Status_Canceled);
        }
        if (status.cancelationRequest) {
            arrayValue.push(leaveRequestStatusCode.Status_Cancel_Request);
        }

        setStatusValue(arrayValue);
    }

    const handleSaveStorageFilter = () => {
        const filter = {
            typeRequest: typeRequest,
            status: status
        }

        storage.saveFilterRequest(filter);
    }

    const toggleDrawer = (open) => (event) => {
        // This is to avoid the drawer to close when we click within the filter div
        const role = event.currentTarget.attributes.role;
        if (role !== undefined && role.value === 'filter') {
            return;
        }

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    const listChild = (items, type) => {
        return (
            items.map((element, index) => (
                <FormControl key={index} className={styles.itemsFilter}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={(type === 'typeRequest' ? typeRequest[element.key] : status[element.key]) || false}
                                onChange={(event) => onChangeFilter(event, element.key, type)}
                                name={`filter-${element.key}`}
                                variant="success"
                            />
                        }
                        label={i18next.t(`request:${type === 'typeRequest' ? "requestType" : "status"}.${element.key}`)}
                        labelPlacement="end"
                    />
                </FormControl>
            )))
    }

    const list = (
        <div
            role="filter"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            {listFilter.map((obj, index) => (
                <React.Fragment key={index}>
                    <List>
                        <ListItem>
                            <ListItemText primary={obj.typeFilter} />
                        </ListItem>
                    </List>

                    {listChild(obj.items, obj.key)}
                    <Divider />
                </React.Fragment>
            ))}
        </div>
    );

    const onChangeFilter = (event, key, typeFilter) => {
        if (typeFilter === 'typeRequest') {
            setTypeRequest({
                ...typeRequest,
                [key]: event.target.checked
            });
        }
        else {
            setStatus({
                ...status,
                [key]: event.target.checked
            });
        }
    }

    return (
        <div id="divFilterRequest">
            <React.Fragment>
                <AppBar position="static" className={classes.appBar}>
                    <Toolbar className={classes.toolBar}>
                        <Button startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="inherit" onClick={handleOpenFilter}>{i18next.t('request:filter.button')}</Button>
                    </Toolbar>
                </AppBar>
                <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)}>

                    {list}
                    <Button className={styles.buttonFilter} startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="primary" onClick={handleFilterSubmit}>{i18next.t('request:filter.button')}</Button>
                </Drawer>
            </React.Fragment>
        </div>
    );
}

export default withNamespaces(['request'], { wait: true })(FilterRequest);

FilterRequest.propTypes = {
    handleFilter: PropTypes.func.isRequired
}